import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import InfiniteScroll from "react-infinite-scroll-component";
import ClipLoader from "react-spinners/ClipLoader";
import backend from "../../../../api";
import useDebounce from "../../Dashboard/components/AdWorkShop/hooks/useDebounce";
import { toast } from "react-toastify";

const AdCardShareModal = ({ open, setOpen, card }) => {
  const [contacts, setContacts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [step, setStep] = useState(1);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [message, setMessage] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [openLoading, setOpenLoading] = useState(true);

  const { user } = useSelector((state) => state.auth);
  const debouncedSearch = useDebounce(search, 500);

  const handleClose = () => {
    setOpen(false);
    // setSelectedContacts([]);
    // setMessage("");
    // setSearch("");
    // setCurrentPage(1);
    // setTotalPages(1);
    // setContacts([]);
  };

  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
    setSelectedContacts([]);
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
    setContacts([]);
    setCurrentPage(1);
    setTotalPages(1);
  };

  const handleCheckBox = (e) => {
    const selectedContact = JSON.parse(e.target.value);
    if (e.target.checked) {
      setSelectedContacts((prev) => [...prev, selectedContact]);
    } else {
      setSelectedContacts((prev) =>
        prev.filter((contact) => contact._id !== selectedContact._id)
      );
    }
  };

  const handleShare = async () => {
    setOpenLoading(true);
    try {
      const userEmails = selectedContacts.map((el) => el?.email);
      const payload = {
        sender_email: user.user.email,
        send_emails: userEmails,
        shared_link: card.shareable_link,
        product_details: card.product.product_discription,
        member_user: user.user._id,
        message: message,
        selectAll: selectAll,
      };
      const response = await backend.post("/sharedlink/sendemails", payload);
      if (response) {
        handleClose();
        toast.success("Card Shared Successfully");
      }
    } catch (error) {
      console.error("error: ", error);
    } finally {
      setOpenLoading(false);
    }
  };

  const handleStepper = (step) => {
    setStep(step);
  };

  const getContactList = async (search = "", page = 1) => {
    try {
      const params = {
        member: user.user._id,
        page: page,
        limit: 10,
        search: search,
      };
      const {
        data: { data, totalPages, currentPage },
      } = await backend.get("/membercontacts", { params });
      if (currentPage === 1) {
        setContacts(data);
      } else {
        setContacts((prevContacts) => [...prevContacts, ...data]);
      }
      setTotalPages(totalPages);
      setCurrentPage(currentPage);
    } catch (error) {
      console.error("error: ", error);
    } finally {
      setOpenLoading(false);
    }
  };

  const fetchMoreData = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    getContactList(debouncedSearch, currentPage);
  }, [currentPage, user, debouncedSearch]);

  return (
    <Modal open={open} onClose={handleClose} center>
      <div className="container px-5 pt-5 custom-modal">
        <div className="row">
          <div className="col-12">
            <h2>Select Contacts</h2>
          </div>

          {step === 1 ? (
            <>
              <div className="col-12 mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <input
                    type="text"
                    className="form-control mb-0 mr-2"
                    placeholder="Search contacts"
                    onChange={handleSearch}
                    value={search}
                  />
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="select-all"
                      className="mr-2"
                      onChange={handleSelectAll}
                      checked={selectAll}
                    />
                    <label htmlFor="select-all" className="mb-0 text-nowrap">
                      Select All
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="col-12"
                id="scrollableDiv"
                style={{ maxHeight: 320, overflow: "auto" }}
              >
                {openLoading ? (
                  <div className=" d-flex justify-content-center w-100 py-5">
                    <ClipLoader
                      color={"#000000"}
                      loading={openLoading}
                      size={60}
                    />
                  </div>
                ) : contacts?.length > 0 ? (
                  <InfiniteScroll
                    dataLength={contacts.length}
                    next={fetchMoreData}
                    hasMore={currentPage < totalPages}
                    loader={<h4>Loading...</h4>}
                    scrollableTarget="scrollableDiv"
                  >
                    <div className="row">
                      {contacts?.map((el, index) => {
                        return (
                          <div className="col-6" key={index}>
                            <label
                              htmlFor={`contact-${index}`}
                              className="card p-2 mb-2"
                            >
                              <div className="d-flex align-items-baseline">
                                <input
                                  id={`contact-${index}`}
                                  name={`contact-${index}`}
                                  type="checkbox"
                                  className="ml-50 mr-2"
                                  value={JSON.stringify(el)}
                                  onChange={handleCheckBox}
                                  disabled={selectAll ? true : false}
                                  checked={
                                    selectAll
                                      ? selectAll
                                      : selectedContacts.some(
                                          (contact) => contact?._id === el?._id
                                        )
                                  }
                                />
                                <div className="d-flex flex-column">
                                  <span>{el?.name}</span>
                                  <small className="text-muted">
                                    {el?.email}
                                  </small>
                                  <small className="text-muted">
                                    {el?.phone}
                                  </small>
                                </div>
                              </div>
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </InfiniteScroll>
                ) : (
                  <div className="d-flex justify-content-center align-items-center w-100 h-100">
                    <h3>No Contacts Available</h3>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="col-12">
              <label htmlFor="message">Message</label>
              <textarea
                type="text"
                className="form-control mb-0"
                id="message"
                name="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows="6"
              />
            </div>
          )}

          <div className="col-12 mt-3">
            <div className="d-flex justify-content-end align-items-center">
              {step === 1 ? (
                <button
                  className="btn btn-solid"
                  onClick={() => handleStepper(2)}
                  disabled={selectAll ? false : !selectedContacts?.length}
                  type="button"
                >
                  Next
                </button>
              ) : (
                <>
                  <button
                    className="btn btn-solid mr-2"
                    onClick={() => handleStepper(1)}
                    type="button"
                  >
                    Previous
                  </button>
                  <button
                    className="btn btn-solid"
                    onClick={handleShare}
                    disabled={!message?.length || openLoading}
                    type="button"
                  >
                    {openLoading ? "Sharing..." : "Share"}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AdCardShareModal;
